import React from 'react';
import { useSelector } from 'react-redux';
import { Box, TextField, Typography } from '@mui/material';
import { resolveUserName } from './partsUtils';
import { userStamp } from '../../utils/dateFunctions';

const NoteWithStamp = ({
  label = 'Parts Note', value, onChange, onBlur, byUid, byDate,
}) => {
  const all_users = useSelector(state => state.settings_users?.all_users || []);
  const name = resolveUserName(all_users, byUid);
  const when = byDate ? userStamp(byDate) : '';

  let stamp = '';
  if (name && when) stamp = `Last edited by ${name} on ${when}`;
  else if (name) stamp = `Last edited by ${name}`;
  else if (when) stamp = `Last edited on ${when}`;

  return (
    <Box>
      <TextField
        label={label}
        multiline
        minRows={2}
        fullWidth
        size="small"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {stamp ? (
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.25 }}>
          {stamp}
        </Typography>
      ) : null}
    </Box>
  );
};

export default NoteWithStamp;
